import {BlueButton} from "../../component/button";
import React, {memo, useState} from "react";

interface SiteMap {
    modal:boolean,
}

function FindMapComponent({siteInfo}) {
    const [ siteMap, setSiteMap ] = useState<SiteMap>({modal:false});

    function closeModalHandler() {
        setSiteMap({modal:false})
    }

    function openModalHandler() {
        setSiteMap({modal:true})
    }

    return (
        <>
            {
                siteInfo.parentSiteInfo.name === '공주공장' && siteInfo.name === '솔브레인' ?
                    <BlueButton
                        type={'button'}
                        onClickHandler={openModalHandler}
                        innerHTML={'지도'}/> : ""
            }
            {
                siteMap.modal &&
                <Modal
                    closeModalHandler={closeModalHandler} />
            }
        </>
    )
}

function Modal({closeModalHandler}) {
    return (
        <div className="nv_modal nv_map_modal on">
            <div className="nv_modal_container">
                <div className="nv_modal_header">
                    <h2 id="site-map-title">지도</h2>
                    <p className="nv_modal_close" onClick={closeModalHandler}>닫기</p>
                </div>
                <div className="nv_modal_contents">
                    <table className="nv_table textcenter" id="site_map_table">
                        <tbody id="site_map_table_tbody">
                        <tr>
                            <td>
                                <img src={"/resource/user/images/map.png"} />
                            </td>
                        </tr>
                        </tbody>
                        <tfoot></tfoot>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default memo(FindMapComponent);